<template>
    <div class="d-flex justify-content-center">
      <div class="col-12 col-md-12 col-lg-12">
        <div class="card shadow-sm mb-5">
          <div class="card-body">
            <Input
              container-class=""
              size="md"
              inputClass="form-control form-control-md mb-5"
              name="input-search"
              :isInputGroup="true"
              :placeholder="$t('label.search')"
              :action="loadUseSearch"
              v-model="query.search"
            >
              <template #rightAddon>
                <span class="position-absolute border-0 bg-transparent end-0 top-50 translate-middle" @click="loadUseSearch">
                  <i class="fa fa-search"></i>
                </span>
              </template>
            </Input>
            <div class="d-flex justify-content-between mb-3">
              <Button v-if="$can(abilities.CREATE_PUBLICATION)" type="new" btn-class="btn-sm fs-6 mb-5" style="cursor: pointer;" @click="openPublishModal" btn-text="feed.do_publish"></Button>
              <div class="d-flex">
                <DateRangePicker id="feed-daterangepicker" @update:date="handleRangeDate" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-center">
      <div class="col-12 col-md-12 col-lg-12">
        <div v-if="getFeeds.length > 0" id="contenu">
          <div class="col-12" v-for="(publish, index) in getFeeds" :key="index">
            <PublishCard :detail="publish" :id="index" :project="project" @loadFeeds="chargeFeeds"/>
          </div>
        </div>
        <div class="card" v-else>
          <div class="h-350px d-flex justify-content-center align-items-center" >
            <div class="text-center ">
              <div>
                <Img filename="empty.png" alt=""
                      class="mw-100 h-125px h-sm-175px" />
              </div>
              <h2 class="fs-2x fw-bolder mb-0">{{ $t('feed.noData') }}</h2>
            </div>
          </div>
        </div>
      </div>
    </div>
    <CreatePublish id="create_publish_modal" @load="chargeFeeds"/>
</template>

<script setup>
  import { useRoute } from "vue-router";
  import { useStore } from "vuex";
  import { computed, ref, watch, onMounted, nextTick, onUpdated } from "vue";
  import Button from "@/components/Button";
  import Input from "@/components/Input.vue";
  import DateRangePicker from "@/components/DateRangePicker.vue";
  import PublishCard from "./components/PublishCard.vue"
  import CreatePublish from "./modals/CreatePublish.vue"
  import Img from "@/components/Img.vue";
import abilities from "@/composables/abilities";

  const route = useRoute();
  const store = useStore();

  const props = defineProps({
    project: {
      type: Object,
      default: {}
    }
  });

  const query = ref({
    start_date: '',
    end_date: '',
    search: ''
  });
  const $feeds = ref('');

  const getFeeds = computed(() => (store.getters['feeds/getFeeds']));
  const getFeedsCount = computed(() => (store.getters['feeds/getFeedsCount']));

  watch(() => [query.value.start_date, query.value.end_date], (newValue) => {
    chargeFeeds();
  });

  watch(() => query.value.search, async(value) => {
    if (!value) {
      chargeFeeds()
    }
  });

  watch(() => route.query.tab, (value) => {
    chargeFeeds();
  }, { deep: true });

  function handleRangeDate(range) {
    query.value.start_date = range.start_date;
    query.value.end_date = range.end_date;
  }

  function loadUseSearch() {
    if (query.value.search) {
      chargeFeeds();
    }
  }

  async function chargeFeeds() {
    await loadData().finally(() => initScroll());
  }

  async function loadData() {
    if (query.value.start_date && query.value.end_date) {
      await store.dispatch("feeds/loadFeeds", { project_id: route.params.id, ...query.value });
    }
  }

  function openPublishModal() {
    $('#create_publish_modal').modal('toggle');
  }

  onMounted(async () => {
    query.value.office = route.query.office;
    store.dispatch('feeds/loadFeedReactions');
    await chargeFeeds().then(() => {
      $feeds.value = document.getElementById('contenu');
    });
  });

  async function onScroll() {
    const feedContainer = $feeds.value;
    if (feedContainer.scrollHeight - feedContainer.scrollTop === feedContainer.clientHeight) {
      if (getFeeds.value.length < getFeedsCount.value) {
        removeScrollEvent(); 
        let prevHeight = feedContainer.scrollTop;
        await store.dispatch("feeds/loadNextFeeds", { project_id: route.params.id, ...query.value }).finally(() => {
          nextTick(() => {
            feedContainer.scrollTop = feedContainer.scrollHeight - prevHeight;
            initScroll();
          });
        });
      }
    }
  }

  function initScroll() {
    if (!$feeds.value) {
      $feeds.value = document.getElementById('contenu');
    }
    if ($feeds.value) {
      if (getFeeds.value.length < getFeedsCount.value) {
        $feeds.value.addEventListener('scroll', onScroll);
      }
    }
  }

  function removeScrollEvent() {
    if ($feeds.value) {
      $feeds.value.removeEventListener('scroll', onScroll);
    }
  }
</script>

<style scoped>
  #contenu {
    padding-right: 15px;
    height: calc(90vh - 240px) !important;
    overflow-y: scroll;
    overflow-x: hidden;
  }

  #contenu::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    background-color: #F5F5F5;
  }

  #contenu::-webkit-scrollbar {
    width: 10px;
    background-color: #F5F5F5;
  }

  #contenu::-webkit-scrollbar-thumb {
    border-radius: 8px;
    -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
    background-color: #bcbaba;
  }
</style>